var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMiniLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1298.943,
    height: 1298.943,
    viewBox: "0 0 1298.943 1298.943",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6353",
    "data-name": "Group 6353",
    transform: "translate(-10125.585 18926.383) rotate(-50)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_246",
    "data-name": "Ellipse 246",
    transform: "translate(20466 -3955)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 50
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 461,
    cy: 461,
    r: 461,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 461,
    cy: 461,
    r: 436,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_132",
    "data-name": "Line 132",
    y2: 909,
    transform: "translate(20927.5 -3941.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 50
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_133",
    "data-name": "Line 133",
    x1: 426,
    transform: "translate(20942.5 -3493.5)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 50
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogo);
export default __webpack_public_path__ + "static/media/mini_logo.9eb69ea050c2fb4a744ed87bab8c7a06.svg";
export { ForwardRef as ReactComponent };